import { Component } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OnboardingService } from 'src/app/services/onboarding.service';

@Component({
  selector: 'app-download-nb-pack',
  templateUrl: './download-nb-pack.component.html',
  styleUrls: ['./download-nb-pack.component.sass'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    ProgressSpinnerModule,
  ],
})
export class DownloadNBPackComponent {
  isDownloadInProgress = false;
  errorMessage = '';
  downloadForm = this.fb.group({
    policyCode: ['', Validators.required],
    fromArchived: [false],
  });

  constructor(
    private fb: FormBuilder,
    private onboardingService: OnboardingService,
    public dialogRef: DynamicDialogRef<DownloadNBPackComponent>
  ) {}

  download() {
    if (this.downloadForm.invalid || this.isDownloadInProgress) return;

    let policyCode =
      this.downloadForm.controls.policyCode.value?.trim().toUpperCase() ?? '';
    let fromArchived = this.downloadForm.controls.fromArchived.value ?? false;

    this.isDownloadInProgress = true;
    this.errorMessage = '';

    this.onboardingService.getNBPack(policyCode, fromArchived).subscribe({
      next: (res) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(res);
        a.href = objectUrl;
        a.download = `MyChillWF_${policyCode}_NBPACK`;
        a.click();
        URL.revokeObjectURL(objectUrl);

        this.isDownloadInProgress = false;
        this.dialogRef.close();
      },
      error: (e) => {
        this.isDownloadInProgress = false;
        this.errorMessage =
          'Unable to download the NB Pack. Please check the policy code and try again.';
        console.error(e);
      },
    });
  }

  close() {
    this.dialogRef.close();
  }
}
